var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1423_14642)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.1026 10.9512H14.9211C14.683 10.9512 14.4547 11.0457 14.2864 11.2141C14.118 11.3824 14.0234 11.6108 14.0234 11.8489V22.621C14.0234 22.8591 14.118 23.0875 14.2864 23.2558C14.4547 23.4242 14.683 23.5187 14.9211 23.5187H22.1026C22.3407 23.5187 22.569 23.4242 22.7373 23.2558C22.9057 23.0875 23.0003 22.8591 23.0003 22.621V11.8489C23.0003 11.6108 22.9057 11.3824 22.7373 11.2141C22.569 11.0457 22.3407 10.9512 22.1026 10.9512Z",
    stroke: "#3E3E3E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1026 1.35742H14.9211C14.683 1.35742 14.4547 1.452 14.2864 1.62035C14.118 1.7887 14.0234 2.01702 14.0234 2.2551V5.86379C14.0234 6.10187 14.118 6.3302 14.2864 6.49855C14.4547 6.66689 14.683 6.76147 14.9211 6.76147H22.1026C22.3407 6.76147 22.569 6.66689 22.7373 6.49855C22.9057 6.3302 23.0003 6.10187 23.0003 5.86379V2.2551C23.0003 2.01702 22.9057 1.7887 22.7373 1.62035C22.569 1.452 22.3407 1.35742 22.1026 1.35742Z",
    stroke: "#3E3E3E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.93657 1.35742H1.7551C1.51702 1.35742 1.2887 1.452 1.12035 1.62035C0.951999 1.7887 0.857422 2.01702 0.857422 2.2551V13.0273C0.857422 13.2654 0.951999 13.4937 1.12035 13.6621C1.2887 13.8304 1.51702 13.925 1.7551 13.925H8.93657C9.17465 13.925 9.40298 13.8304 9.57132 13.6621C9.73967 13.4937 9.83425 13.2654 9.83425 13.0273V2.2551C9.83425 2.01702 9.73967 1.7887 9.57132 1.62035C9.40298 1.452 9.17465 1.35742 8.93657 1.35742Z",
    stroke: "#3E3E3E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.93657 18.1133H1.7551C1.51702 18.1133 1.2887 18.2079 1.12035 18.3762C0.951999 18.5446 0.857422 18.7729 0.857422 19.011V22.6196C0.857422 22.8577 0.951999 23.0861 1.12035 23.2544C1.2887 23.4228 1.51702 23.5173 1.7551 23.5173H8.93657C9.17465 23.5173 9.40298 23.4228 9.57132 23.2544C9.73967 23.0861 9.83425 22.8577 9.83425 22.6196V19.011C9.83425 18.7729 9.73967 18.5446 9.57132 18.3762C9.40298 18.2079 9.17465 18.1133 8.93657 18.1133Z",
    stroke: "#3E3E3E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1423_14642"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardIcon);
export default __webpack_public_path__ + "static/media/dashboard-icon.e7f970f181f5db6db438ae0e55c71409.svg";
export { ForwardRef as ReactComponent };